import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { lenexaConfig } from "./data";

export default function LenexaPage() {
  return <CityPageTemplate config={lenexaConfig} />;
}